import { Box, Button, Flex, Text } from "@chakra-ui/react";
import useUpgrade from "../../../shared/hooks/useUpgrade";

const PreviewProgress = ({ paywall, isPremium }) => {
  const upgrade = useUpgrade();
  if (isPremium || !paywall?.previewEnabled) return null;
  const limit = paywall.previewLimit || 0;
  if (!limit) return null;
  const used = Math.min(paywall.previewUsed, limit);
  const filledSegments = Math.ceil((used / limit) * 5);
  return (
    <Box w="100%" maxW="container.lg" px="5" py="1.5" role="status">
      <Flex align="center">
        <Flex
          flex="0 0 auto"
          w={{ base: "90px", sm: "160px", md: "200px" }}
          gap="6px"
        >
          {Array.from({ length: 5 }, (_, index) => (
            <Box
              key={index}
              flex="1"
              h="6px"
              borderRadius="full"
              bg={index < filledSegments ? "#FFAA00" : "#30384E"}
            />
          ))}
        </Flex>
        <Text
          flex="1"
          minW={0}
          ml="12px"
          color="#8F9BB3"
          fontSize="14px"
          lineHeight="19px"
          isTruncated
        >
          {used} of {limit} free
        </Text>
        <Button
          flexShrink={0}
          variant="ghost"
          size="sm"
          ml="2"
          px="10px"
          color="#FFAA00"
          fontWeight="700"
          borderRadius="md"
          whiteSpace="nowrap"
          _hover={{ bg: "rgba(255, 170, 0, 0.12)" }}
          onClick={upgrade}
        >
          Go Premium
        </Button>
      </Flex>
      {paywall.isReadOnly && (
        <>
          <Text fontSize="sm" mt="3">
            Your progress is safe. Upgrade to Premium to continue tracking.
          </Text>
          <Button colorScheme="red" size="sm" mt="3" onClick={upgrade}>
            Upgrade to Premium
          </Button>
        </>
      )}
    </Box>
  );
};
export default PreviewProgress;
